import React from 'react';

import './index.scss';

export type SelectorChipShape = 'pill' | 'round' | 'cell';
export type SelectorChipTone = 'accent' | 'soft';

export interface SelectorChipProps {
  selected?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  /** pill (padrão, cantos 20px) · round (999px) · cell (grade, cantos 10px, empilha conteúdo). */
  shape?: SelectorChipShape;
  /** accent (padrão, preenchimento azul) · soft (destaque leve, para multiseleção). */
  tone?: SelectorChipTone;
  disabled?: boolean;
  /** 'tab' → aria-selected · 'checkbox' → aria-checked · ausente → aria-pressed. */
  role?: string;
  className?: string;
}

/**
 * Chip/pílula selecionável — fonte única de verdade para os seletores de conteúdo mobile
 * (família "chip de seleção" do NAV_HIERARCHY.md). Base clara com borda; estado selecionado
 * com preenchimento accent `#3a7cbf` (ou `soft` para multiseleção). O conteúdo é livre
 * (`children`), então rótulos, ícones e células de data continuam flexíveis.
 */
export default function SelectorChip({
  selected = false,
  onClick,
  children,
  shape = 'pill',
  tone = 'accent',
  disabled = false,
  role,
  className = '',
}: SelectorChipProps) {
  const classes = [
    'ds-selector-chip',
    `ds-selector-chip-${shape}`,
    selected ? `ds-selector-chip-selected ds-selector-chip-${tone}` : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      type="button"
      className={classes}
      role={role}
      aria-selected={role === 'tab' ? selected : undefined}
      aria-checked={role === 'checkbox' ? selected : undefined}
      aria-pressed={role ? undefined : selected}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
